import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'

import LogoSection from './logosection.js'
import SideBar from './sidebar.js'
import Main from './main.js'
import Footer from './footer.js'
import Info from './info.js'

import NotFound from './notfound.js'

import '../css/app.css'

class App extends Component{
	
	render(){
		return (
			<div id = "wrapper">
				<div id="wrapper-center">
					<LogoSection />
					<SideBar />
					
					<Switch>
						{Object.values(Info).map((route, index) => (
							<Route
								key={index}
								path={route.path}
								exact={route.exact}
								component={Main}
							/>
						))}
						<Redirect from="/" to="/rentayventa"/>
						<Route component={NotFound}/>  
					</Switch>
					
					<Footer />
				</div>
			</div>
		);
	}
}

export default App

/*
<div id = "wrapper">
	<div id="wrapper-center">
		<div id = "content">
		</div>
	</div>
</div>

<LogoSection />
<SideBar />
<div id = "content">
	<Switch>
		{routes.map((route, index) => (
			<Route
				key={index}
				path={route.path}
				exact={route.exact}
				component={Main}
			/>
		))}
		<Route component={NotFound}/>  
	</Switch>
</div>
<Footer />
*/


// WEBPACK FOOTER //
// ./src/components/app.js